(() => {
  'use strict';
  const init = () => document.querySelectorAll('.ss-commerce:not([data-v6-ready])').forEach(root => {
    root.dataset.v6Ready = 'true';
    const thumbnailRail = root.querySelector('.ss-thumbnails');
    const thumbnailObserver = thumbnailRail ? new MutationObserver(() => {
      const selected = thumbnailRail.querySelector('[aria-pressed="true"]');
      if (!selected || thumbnailRail.scrollWidth <= thumbnailRail.clientWidth) return;
      const railBox = thumbnailRail.getBoundingClientRect(), itemBox = selected.getBoundingClientRect();
      let left = thumbnailRail.scrollLeft;
      if (itemBox.left < railBox.left+2) left -= railBox.left+2-itemBox.left;
      else if (itemBox.right > railBox.right-2) left += itemBox.right-railBox.right+2;
      if (left !== thumbnailRail.scrollLeft) thumbnailRail.scrollTo({left,behavior:'auto'});
    }) : null;
    if (thumbnailRail) thumbnailObserver.observe(thumbnailRail,{subtree:true,attributes:true,attributeFilter:['aria-pressed']});
    const navigation = root.querySelector('.ss-product-tabs');
    const navLinks = [...(navigation?.querySelectorAll('a') || [])];
    const highlight = link => navLinks.forEach(item => {
      if (item === link) item.setAttribute('aria-current','location');
      else item.removeAttribute('aria-current');
    });
    navLinks.forEach(link => link.addEventListener('click', () => highlight(link)));
    const navObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      const entry = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top-b.boundingClientRect.top)[0];
      if (entry) highlight(navLinks.find(link => link.hash === '#'+entry.target.id));
    }, {rootMargin:'-12% 0px -65% 0px'}) : null;
    navLinks.forEach(link => {const target = root.querySelector(link.hash); if (target) navObserver?.observe(target);});
    const dialog = root.querySelector('.ss-video-dialog');
    const video = dialog.querySelector('video');
    const fullStory = dialog.querySelector('[data-full-story]');
    const drawer = dialog.querySelector('[data-story-drawer]');
    const storyDetails = drawer.querySelector('details');
    const fallback = dialog.querySelector('[data-video-fallback]');
    const error = dialog.querySelector('.ss-video-error');
    let opener = null, playRequest = 0;
    const clear = () => {
      playRequest++;
      video.pause();
      video.querySelectorAll('track').forEach(t => t.remove());
      video.removeAttribute('src'); video.removeAttribute('poster'); video.load();
    };
    const openVideo = button => {
      if (!button) return;
      clear(); opener = button;
      dialog.querySelector('#ss-video-title').textContent = button.dataset.videoTitle;
      fallback.textContent = button.dataset.videoTranscript || '';
      fallback.hidden = true; storyDetails.open = false;
      error.hidden = true;
      const source = root.querySelector(`template[data-story-for="${button.dataset.storyKey || ''}"]`);
      fullStory.replaceChildren();
      if (source) {
        const content = source.content.cloneNode(true);
        drawer.querySelector('[data-story-intro]').textContent = content.querySelector('h3')?.textContent || '';
        content.querySelector('h3')?.remove();
        fullStory.append(content);
        drawer.querySelector('[data-story-toggle]').textContent = `Read ${source.dataset.storyName}’s full story`;
      }
      drawer.hidden = !source;
      dialog.classList.toggle('ss-video-dialog--story', Boolean(source));
      video.poster = button.querySelector('img')?.currentSrc || '';
      video.src = button.dataset.ssVideo;
      if (button.dataset.videoCaptions) {
        const track = document.createElement('track');
        track.kind = 'captions'; track.label = 'English'; track.srclang = 'en';
        track.src = button.dataset.videoCaptions; track.default = true;
        video.append(track); track.track.mode = 'showing';
      }
      dialog.showModal(); dialog.scrollTop = 0; document.body.style.overflow = 'hidden';
      const request = playRequest;
      video.play().catch(() => {
        if (dialog.open && request === playRequest && video.error) error.hidden = false;
      });
    };
    root.querySelectorAll('[data-ss-video]').forEach(b => b.addEventListener('click', () => openVideo(b)));
    root.querySelector('[data-video-forward="expert"]')?.addEventListener('click', () => openVideo(root.querySelector('.ss-expert-poster')));
    dialog.querySelector('[data-close-video]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {clear(); document.body.style.overflow = ''; opener?.focus({preventScroll:true});});
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
    video.addEventListener('error', () => {if (video.getAttribute('src')) {
      error.hidden = false;
      if (!drawer.hidden) storyDetails.open = true;
      else fallback.hidden = !fallback.textContent;
    }});

    const wall = root.querySelector('[data-review-library-url]');
    if (!wall) return;
    const grid = wall.querySelector('[data-review-grid]'), count = wall.querySelector('[data-review-count]');
    const progress = wall.querySelector('[data-review-progress]');
    const more = wall.querySelector('[data-load-reviews]'), filters = [...wall.querySelectorAll('[data-review-filter]')];
    const media = JSON.parse(wall.querySelector('[data-review-media]').textContent);
    const pageSize = Math.min(24, Math.max(3, Number(wall.dataset.reviewPageSize) || 6));
    let data = null, pending = null, active = 'all', visible = pageSize;
    const sizeCard = card => {
      if (!grid.classList.contains('ss-review-grid--masonry')) return;
      card.style.gridRowEnd = 'span '+Math.ceil((card.getBoundingClientRect().height+20)/8);
    };
    const cardObserver = 'ResizeObserver' in window ? new ResizeObserver(entries => entries.forEach(entry => sizeCard(entry.target))) : null;
    if (cardObserver) {
      grid.classList.add('ss-review-grid--masonry');
      [...grid.children].forEach(card => {sizeCard(card);cardObserver.observe(card);});
    }
    const el = (tag, className, text) => {
      const node = document.createElement(tag); if (className) node.className = className;
      if (text !== undefined) node.textContent = text; return node;
    };
    const renderCard = review => {
      const card = el('article','ss-review ss-review-v6');
      card.dataset.reviewId = review.id; card.dataset.reviewTopic = review.topic;
      card.tabIndex = -1;
      const person = el('div','ss-review-person');
      const initials = el('span','ss-review-initials',review.name.split(/\s+/).slice(0,2).map(s=>s[0]).join(''));
      initials.setAttribute('aria-hidden','true'); person.append(initials);
      const identity = el('div'); identity.append(el('strong','',review.name),el('span','',review.topicLabel));
      person.append(identity); card.append(person);
      if (review.title) card.append(el('h3','',review.title));
      const quote = el('blockquote','ss-review-text',review.text); quote.id = `review-copy-${review.id}`; card.append(quote);
      if (review.text.length > 290) {
        quote.classList.add('ss-review-text--clamped');
        const toggle = el('button','ss-review-expand','Read full review'); toggle.type='button';
        toggle.setAttribute('aria-expanded','false'); toggle.setAttribute('aria-controls',quote.id);
        toggle.addEventListener('click',()=>{
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded',String(expanded)); quote.classList.toggle('ss-review-text--clamped',!expanded);
          toggle.textContent = expanded ? 'Show less' : 'Read full review'; sizeCard(card);
        }); card.append(toggle);
      }
      if (review.image && media[review.image]) {
        const image = el('img','ss-review-photo'); image.src=media[review.image];
        image.alt=review.imageAlt || 'A casual everyday moment'; image.width=640; image.height=480;
        image.loading='lazy'; image.decoding='async'; card.append(image);
      }
      return card;
    };
    const render = (append = false) => {
      const matching = data.filter(r => active === 'all' || r.topic === active);
      const shown = matching.slice(0,visible);
      const priorCount = append ? grid.children.length : 0;
      if (!append) {cardObserver?.disconnect(); grid.replaceChildren();}
      const newCards = shown.slice(priorCount).map(renderCard);
      grid.append(...newCards);
      newCards.forEach(card => {sizeCard(card); cardObserver?.observe(card);});
      count.textContent = `Showing ${shown.length} of ${matching.length} ${active === 'all' ? 'reviews' : 'matching reviews'}`;
      progress.textContent = `${shown.length} of ${matching.length} ${active === 'all' ? 'reviews' : 'matching reviews'}`;
      more.hidden = shown.length >= matching.length; more.disabled=false;
      more.textContent = `Load ${Math.min(pageSize,matching.length-shown.length)} more reviews`;
      wall.setAttribute('aria-busy','false');
      root.querySelectorAll('[data-review-total]').forEach(label => {label.textContent = String(data.length);});
      if (append && newCards[0]) requestAnimationFrame(() => {
        newCards[0].scrollIntoView({block:'start'}); newCards[0].focus({preventScroll:true});
      });
    };
    const load = () => {
      if (data) return Promise.resolve(data);
      if (pending) return pending;
      pending = fetch(wall.dataset.reviewLibraryUrl,{credentials:'omit'}).then(r=>{
        if (!r.ok) throw new Error('Review library unavailable'); return r.json();
      }).then(rows=>{
        if (!Array.isArray(rows) || !rows.length || rows.some(r=>!r.id || !r.name || !r.text || !r.topic)) throw new Error('Invalid review library');
        data=rows; render(); return data;
      }).catch(()=>{
        count.textContent='More reviews could not load. Please try again.';
        more.hidden=false; more.disabled=false; more.textContent='Try loading reviews again';
        wall.setAttribute('aria-busy','false');
        return null;
      }).finally(()=>{pending=null;});
      return pending;
    };
    filters.forEach(button=>button.addEventListener('click',async()=>{
      active=button.dataset.reviewFilter; visible=pageSize;
      filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      if (await load()) render();
    }));
    more.addEventListener('click',async()=>{
      more.disabled=true; more.textContent='Loading reviews…'; wall.setAttribute('aria-busy','true');
      if (await load()) {visible+=pageSize; render(true);}
    });
    document.addEventListener('shopify:section:unload', e => {
      if (e.target.contains(root)) {cardObserver?.disconnect();navObserver?.disconnect();thumbnailObserver?.disconnect();clear();}
    });
    if ('IntersectionObserver' in window) {
      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'500px'});
      observer.observe(wall);
    } else load();
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',init) : init();
  document.addEventListener('shopify:section:load',init);
})();
